import React from 'react';

//CORE COMPONENTS
import { LazyImage } from '../../../components-core/packages/components-core/dist/image';
import { Text, TextAppearance, WhiteSpace } from '../../../components-core/packages/components-core/dist/text';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

class CampaignDetail extends React.Component {

    renderHeadline() {
        const splittedHeadline = this.props.custom.split('//');
        const renderedTexts = splittedHeadline.map((text, index) => 
                <Text 
                    appearance={TextAppearance.headline0400}  
                    whiteSpace={WhiteSpace.preLine} 
                    wordBreak bold={index % 2 === 1} 
                >
                    {text}&nbsp;
                </Text>
            )

        const finalArray = chunckArray(renderedTexts, 2);
        const renderedFinalArray = finalArray.map(array => 
            <Container padding={headlinePadding} >{array}</Container>
        )

        return (
            <Container 
                wrap={ContainerWrap.always} 
                padding={{ top: ContainerPadding.dynamic0300 }} 
            >
                {renderedFinalArray}
            </Container>
        )
    }

    renderDescription() {
        const { custom1, custom2 } = this.props;
        let renderedTexts;

        try {
            const splittedText = custom1.split('//');
            renderedTexts = splittedText.map(text => 
                <Text 
                    whiteSpace={WhiteSpace.preLine} 
                    appearance={TextAppearance.copy0200} 
                >
                    {text}
                </Text>
            )    
        } catch (error) {
           console.log(error) 
        }

        return (
            <Container 
                padding={descriptionPadding} 
                wrap={ContainerWrap.always}
                gutter={ContainerGutter.dynamic0100}
            >
                {renderedTexts}
                {
                    custom2 &&                 
                    <LazyImage 
                        src={custom2} 
                        srcPlaceholder={custom2} 
                    />
                }

            </Container> 
        )
    }
    
    render() {
        return (
            <Container wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0200}>
                {this.renderHeadline()}
                {this.renderDescription()}
            </Container>
        )
    }
}

export default CampaignDetail;

const headlinePadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid003
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid003
    },
}

const descriptionPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004
    }
}


var chunckArray = function(array, chunkCount) {
    var chunks = [];
    while(array.length){
        chunks.push(array.splice(0, chunkCount));
    }
    return chunks;
}
